export default {
    meta: {
        title: '选择项目',
    },
};
